<div class="quote-accept-page">
  <div v-if="pageState === 'loading'" class="quote-accept-status">
    <p>Loading quote...</p>
  </div>

  <div v-else-if="pageState === 'error'" class="quote-accept-status">
    <h1>Unable to load quote</h1>
    <p>{{ errorMessage }}</p>
  </div>

  <div v-else-if="pageState === 'success'" class="main-container">
    <div class="ui middle aligned center aligned grid">
      <div class="sixteen wide column ">
        <img src="../../../assets/img/icn_success_outline.svg" alt="success-icon">
      </div>
      <div class="sixteen wide column">
        <h1>Thank You!</h1>
        <p>You have successfully accepted quote {{ quoteNumber }} for {{ currency(quoteTotal, '$', 2, { decimalSeperator: ','})}}.</p>
        <p>You can close this window</p>
      </div>
    </div>
  </div>

  <quote-preview
    v-else-if="pageState === 'review'"
    :parent_quote="quote"
    :parent_quote_items="quoteItems"
    :parent_contact="contact"
    :parent_settings="settings"
    :read_only="true"
    :public_accept="true"
    @accepted="onAccepted">
  </quote-preview>
</div>
